import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Information.module.css";
import Button from "../../component/Button";
import i18next from "i18next";
import { fetchDataFromApi } from "../../api/Api";
import stateData from "./States";
import ButtonOld from "../../component/ButtonOld";

const Information = () => {
  const t = i18next.t;
  const navigate = useNavigate();
  const location = useLocation();

  const avatarId = location?.state?.avatarId;
  const mobileId = location?.state?.mobileId;
  // const [stateData, setStateData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [allData, setAllData] = useState({
    selectedState: "",
    selectedDistrict: "",
    selectedCity: "",
    location_name: "",
    is_resident: "",
    gender: "",
    age: "",
  });
  const [valid, setvalid] = useState(false);
  const [formError, setFormError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    let err = {};
    if (allData.selectedState === "") {
      err.selectedState = "State required !";
    }
    if (allData.selectedDistrict === "") {
      err.selectedDistrict = "District required !";
    }
    if (allData.selectedCity === "") {
      err.selectedCity = "City required !";
    }
    if (allData.location_name === "") {
      err.location_name = "Location required !";
    }
    if (allData.is_resident === "") {
      err.is_resident = "Option required !";
    }
    if (allData.gender === "") {
      err.gender = "Gender required !";
    }
    if (allData.age === "") {
      err.age = "Age is required !";
    } else {
      const age = Number(allData.age);
      if (age < 15 || age > 99) {
        err.age = "Age must be between 15 and 99";
      }
    }


    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };

  useEffect(() => {
    // We call validateForm, but we need to change how validateForm works
    // so it doesn't always set the UI errors immediately.
    validateForm(); 
  }, [allData]);

  useEffect(() => {
    const isValid = validateForm();
    setvalid(isValid);
  }, [allData]);


  // const fetchStateData = () => {
  //   fetchDataFromApi("states").then((res) => setStateData(res.data));
  // };
  const fetchDistrictData = () => {
    fetchDataFromApi(`districts/${allData.selectedState}`).then((res) =>
      setDistrictData(res.data)
    );
  };
  const fetchCityData = () => {
    fetchDataFromApi(`ulbs/district/${allData.selectedDistrict}`).then((res) =>
      setCityData(res.data)
    );
  };

  // const handleChange = (e) => {
  //   let isValid = validateForm();
  //   setvalid(isValid);
  //   const { name, value } = e.target;
  //   setAllData(() => ({
  //     ...allData,
  //     [name]: value,
  //   }));
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setAllData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/survey", { state: { allData, avatarId, mobileId } });
  };

  // useEffect(() => {
  //   fetchStateData();
  // }, []);

  useEffect(() => {
    if (allData.selectedState) {
      fetchDistrictData();
    }
  }, [allData.selectedState]);
  useEffect(() => {
    if (allData.selectedDistrict) {
      fetchCityData();
    }
  }, [allData.selectedDistrict]);

  const states = [...stateData].sort((a, b) =>
    a.name > b.name ? 1 : -1
  );

  const districts = [...districtData].sort((a, b) =>
    a.name > b.name ? 1 : -1
  );

  const cities = [...cityData].sort((a, b) => (a.name > b.name ? 1 : -1));

  return (
    <>
      <div className='container'>
        <form
          id='informationForm'
          className={`informationForm ${styles.mainContainer}`}
          onSubmit={handleSubmit}
        >
          <div className={styles.mainWrapper}>
            <div>
              <p className={styles.headingText}>{t("LOCATION")}</p>
              <div className={styles.allSelectors}>
                <div className={styles.Selector}>
                  <select
                    name='selectedState'
                    id='selectedState'
                    className={styles.selectBox}
                    onChange={handleChange}
                  >
                    <option className='text-center'>{t("STATE")}</option>
                    {states?.map((res) => {
                      return (
                        <option
                          key={res.id}
                          value={res.id}
                          className='text-center'
                          text={res.name}
                        >
                          {res.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className={styles.Selector}>
                  <select
                    name='selectedDistrict'
                    id='selectedDistrict'
                    className={styles.selectBox}
                    onChange={handleChange}
                  >
                    <option className='text-center'>{t("DISTRICT")}</option>
                    {districts?.map((res) => {
                      return (
                        <option
                          key={res.id}
                          value={res.id}
                          text={res.name}
                          className='text-center'
                        >
                          {res.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className={styles.Selector}>
                  <select
                    name='selectedCity'
                    id='selectedCity'
                    className={styles.selectBox}
                    onChange={handleChange}
                  >
                    <option className='text-center'>{t("CITY")}</option>
                    {cities?.map((res) => {
                      return (
                        <option
                          key={res.id}
                          value={res.id}
                          text={res.name}
                          className='text-center'
                        >
                          {res.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className={styles.locationSelector}>
                  <input
                    maxLength={50}
                    type='text'
                    id='location_name'
                    name='location_name'
                    className='locationInput'
                    autoComplete='off'
                    onChange={handleChange}
                    placeholder={t("LOCATION_NAME")}
                  />
                </div>
              </div>
            </div>
            <div className="test">
              <p className={styles.resoidentButtonTitle}>
                {t("HAVE_YOU_RESOIDENTS")}
              </p>

              <div className={styles.resoident} onChange={handleChange}>
                <label>
                  <input type='radio' name='is_resident' value='Yes' />
                  <span>{t("YES")}</span>
                </label>
                <label>
                  <input type='radio' name='is_resident' value='No' />
                  <span>{t("NO")}</span>
                </label>
              </div>
            </div>
            <div>
              <p className={styles.genderButtonTitle}>
                {t("RESPONDANT_GENDER")}
              </p>
              <div className={styles.gender} onChange={handleChange}>
                <label>
                  <input type='radio' name='gender' value='M' />
                  <span>{t("MALE")}</span>
                </label>
                <label>
                  <input type='radio' name='gender' value='F' />
                  <span>{t("FEMALE")}</span>
                </label>
                {/* <label>
                  <input type='radio' name='gender' value='T' />
                  <span>{t("TRANS_GENDER")}</span>
                </label> */}
              </div>
            </div>
            <div>
              <p className={styles.ageButtonTitle}>{t("AGE")}</p>
              <div className={styles.ageInputWrapper}>
                <input
                  type="number"
                  className="ageInput"
                  id="age"
                  name="age"
                  onChange={handleChange}
                  min={15}
                  max={99}
                />
              </div>

              {/* {formError.age && (
                <p className={styles.errorText}>{formError.age}</p>
              )} */}
              {allData.age !== "" && formError.age && (
  <p className={styles.errorText}>{formError.age}</p>
)}
            </div>
          </div>
          <div className={styles.bottomButtonWrapper}>
            <ButtonOld
              text='Start Survey'
              type='submit'
              value='Submit'
              disabled={valid === true ? false : true}
            />
          </div>
        </form>
        {/* Footer */}
        <div className={styles.footerStrip}>
          Powered by Swachh Bharat Mission Urban
        </div>
      </div>
    </>
  );
  //   return (
  //     <div className={`container ${styles.pageWrapper}`}>
  //       <form
  //         id="informationForm"
  //         className={styles.formContainer}
  //         onSubmit={handleSubmit}
  //       >
  //         {/* Select State */}
  //         <div className={styles.fieldGroup}>
  //           <label className={styles.label}>Select State</label>
  //           <select
  //             name="selectedState"
  //             className={styles.selectInput}
  //             onChange={handleChange}
  //             value={allData.selectedState}
  //           >
  //             <option value="">Select State</option>
  //             {states.map((res) => (
  //               <option key={res.id} value={res.id}>
  //                 {res.name}
  //               </option>
  //             ))}
  //           </select>
  //         </div>

  //         {/* Select District */}
  //         <div className={styles.fieldGroup}>
  //           <label className={styles.label}>Select District</label>
  //           <select
  //             name="selectedDistrict"
  //             className={styles.selectInput}
  //             onChange={handleChange}
  //             value={allData.selectedDistrict}
  //           >
  //             <option value="">Select District</option>
  //             {districts.map((res) => (
  //               <option key={res.id} value={res.id}>
  //                 {res.name}
  //               </option>
  //             ))}
  //           </select>
  //         </div>

  //         {/* Select Urban Local Body */}
  //         <div className={styles.fieldGroup}>
  //           <label className={styles.label}>Select Urban Local Body</label>
  //           <select
  //             name="selectedCity"
  //             className={styles.selectInput}
  //             onChange={handleChange}
  //             value={allData.selectedCity}
  //           >
  //             <option value="">Select Urban Local Body</option>
  //             {cities.map((res) => (
  //               <option key={res.id} value={res.id}>
  //                 {res.name}
  //               </option>
  //             ))}
  //           </select>
  //         </div>

  //         {/* Location */}
  //         <div className={styles.fieldGroup}>
  //           <label className={styles.label}>{t("LOCATION_NAME")}</label>
  //           <input
  //             type="text"
  //             name="location_name"
  //             placeholder="Type here"
  //             className={styles.textInput}
  //             onChange={handleChange}
  //           />
  //         </div>

  //         {/* Name */}
  //         <div className={styles.fieldGroup}>
  //           <label className={styles.label}>Your Name</label>
  //           <input
  //             type="text"
  //             name="name"
  //             placeholder="Type here"
  //             className={styles.textInput}
  //             onChange={handleChange}
  //           />
  //         </div>

  //         {/* Age */}
  //         <div className={styles.fieldGroup}>
  //           <label className={styles.label}>{t("AGE")}</label>
  //           <input
  //             type="number"
  //             name="age"
  //             placeholder="Type here"
  //             min={15}
  //             max={99}
  //             className={styles.textInput}
  //             onChange={handleChange}
  //           />
  //           {formError.age && (
  //             <p className={styles.errorText}>{formError.age}</p>
  //           )}
  //         </div>

  //         {/* Gender */}
  //         <div className={styles.fieldGroup}>
  //   <label className={styles.label}>{t("RESPONDANT_GENDER")}</label>

  //   <div className={styles.genderWrapper}>
  //     {[
  //       { label: t("MALE"), value: "M" },
  //       { label: t("FEMALE"), value: "F" },
  //       { label: t("TRANS_GENDER"), value: "T" },
  //     ].map((item) => (
  //       <button
  //         type="button"
  //         key={item.value}
  //         className={`${styles.genderBtn} ${
  //           allData.gender === item.value ? styles.activeGender : ""
  //         }`}
  //         onClick={() =>
  //           setAllData((prev) => ({ ...prev, gender: item.value }))
  //         }
  //       >
  //         {item.label}
  //       </button>
  //     ))}
  //   </div>
  // </div>

  //         <label className={styles.label}>{t("HAVE_YOU_RESOIDENTS")}</label>
  //         <div className={styles.residentButtons}>

  //             <button
  //               type="button"
  //               className={`${styles.yesBtn} ${
  //                 allData.is_resident === "Yes" ? styles.activeYes : ""
  //               }`}
  //               onClick={() =>
  //                 setAllData((prev) => ({ ...prev, is_resident: "Yes" }))
  //               }
  //             >
  //             {t("YES")}
  //             </button>

  //             <button
  //               type="button"
  //               className={`${styles.noBtn} ${
  //                 allData.is_resident === "No" ? styles.activeNo : ""
  //               }`}
  //               onClick={() =>
  //                 setAllData((prev) => ({ ...prev, is_resident: "No" }))
  //               }
  //             >
  //            {t("NO")}
  //             </button>
  //           </div>

  //         {/* Submit */}
  //         <div className={styles.submitWrapper}>
  //           <Button
  //             text="START SURVEY"
  //             type="submit"
  //               disabled={valid === true ? false : true}
  //           />
  //         </div>
  //       </form>
  //     </div>
  //   );

};

export default Information;
